import { TExpirationDateType, TFileDataType } from './general.types';

export enum EVetRecordStatus {
  NOT_VERIFIED = 'NOT_VERIFIED',
  VERIFIED = 'VERIFIED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum EVetRecordStatusUi {
  NOT_VERIFIED = 'Not verified',
  VERIFIED = 'Verified',
  IN_PROGRESS = 'Verification in progress',
}

export type TAnimalVetRecord = {
  documentFiles: TFileDataType[];
  id: string;
  records: TVetRecordDB[];
};

export type TAnimalVetRecordUi = {
  documentFiles: TFileDataType[];
  id: string;
  records: TVetRecordUI[];
  canEdit: boolean;
};

export type TVetRecordDB = {
  id: string;
  type: TVetRecordTypeDB;
  expiration: TExpirationDateType | null;
  isExpired: boolean;
  requiredByVerificationConfiguration: boolean;
  isLocked?: boolean;
  verificationStatus?: EVetRecordStatus;
};
export type TVetRecordUI = {
  id: string;
  type: TVetRecordTypeUI;
  expiration: TExpirationDateType | null;
  isExpired?: boolean;
  requiredByVerificationConfiguration?: boolean;
  isLocked?: boolean;
  verificationStatus?: EVetRecordStatusUi;
};

export type TVetRecordTypeDB = {
  predefined?: string;
  custom?: string;
  value: string;
};
export type TVetRecordTypeUI = {
  predefined?: string;
  custom?: string;
  value: string;
};
